<template>
    <div class="p-grid p-fluid p-justify-center p-nogutter">
        <Toast position="bottomright"></Toast>
        <router-view></router-view>
    </div>
</template>

<script>
    import {JwtToken} from "@/utils/jwt";

    export default {
        name: "app",
        metaInfo() {
            return {
                title: this.$t("homeTitle"),
                htmlAttrs: {
                    lang: this.$i18n.locale,
                    amp: true
                }
            }
        },
        created() {
            window.addEventListener("storage", (event) => {
                if (event.key === 'access_token') {
                    const oldOrgId = new JwtToken(event.oldValue).organizationId();
                    const newOrgId = new JwtToken(event.newValue).organizationId();
                    if (oldOrgId !== newOrgId) {
                        alert('Du har skiftet til anden organisation. Genopfrisk data');
                        location.reload();
                    }
                }
            });
        }
    };
</script>

<style lang="scss">
    @import './App.scss';
</style>

<i18n lang="yaml" locale="en">
    homeTitle: "Intersolia Denmark - Your Environmental Management Partner"
</i18n>

<i18n lang="yaml" locale="dk">
    homeTitle: "Intersolia Danmark - Din partner i miljøledelse"
</i18n>
